import {Fragment, useState} from 'react';
import React from "react";
import ListEdit from "../UI/ListEdit";
import {usePayouts} from "../../hooks/usePayouts";
import {convertToDisplayDate} from "../../utility/utility";
import {useNavigate} from "react-router-dom";

const PayoutList = (props) => {
    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(20);
    const {payouts, pagination} = usePayouts(props.fromDate, props.toDate, page, pageSize, 0);
    const navigate = useNavigate();

    const payoutList = payouts.map((item) => {
        return {
            payoutId    : item.payoutId,
            availableOn : convertToDisplayDate(item.availableOn),
            status      : item.status,
            gross       : item.gross + ' ' + item.currency,
            fee         : item.fee + ' ' + item.currency,
            net         : item.net + ' ' + item.currency
        };
    });

    const handlePageChange = (pageNumber) => {
        setPage(pageNumber);
    };

    const handlePageSizeChange = (pageSize) => {
        setPageSize(pageSize);
        setPage(1);
    };

    const listHeaders = [
        'Id',
        'Available on',
        'Status',
        'Gross',
        'Fee',
        'Payout',
        'Actions'
    ];

    const columns = {
        functionParams : ['payoutId'],
        dataKeys       : [
            'payoutId',
            'availableOn',
            'status',
            'gross',
            'fee',
            'net'
        ],
    }

    const handleShowIconClick = (payoutId) => {
        navigate('/payouts/' + payoutId + '/transactions');
    }

    return <Fragment>
        <ListEdit
            headers={listHeaders}
            items={payoutList}
            columns={columns}
            pagination={pagination}
            handlePageChange={handlePageChange}
            handlePageSizeChange={handlePageSizeChange}
            handleShowIconClick={handleShowIconClick}
        />
    </Fragment>;
}

export default PayoutList;
